import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { RedirectionService } from '@app/core/services/redirection.service';
import * as fromRoot from '@app/reducers';
import { Store } from '@ngrx/store';
import { Observable, ReplaySubject } from 'rxjs';
import { map, takeUntil, withLatestFrom } from 'rxjs/operators';
import { Constant } from 'src/constant';
import { AccountActions } from '../../actions';

@Injectable({
  providedIn: 'root'
})
export class IsSubscriptionValidGuard {

  constructor(
    private store$: Store<fromRoot.State>,
    private router: Router,
    private redirectionService: RedirectionService,
  ) { }

  canActivate(): Observable<boolean> {
    return this.isSubscriptionValid().pipe(map((isSubscriptionValid: boolean) => {
      return isSubscriptionValid;
    }));
  }

  isSubscriptionValid(): Observable<boolean> {
    this.store$.dispatch(AccountActions.loadSubscriptionWithPlan());
    const isSubscriptionValid$ = new ReplaySubject<boolean>();
    this.store$.pipe(
      withLatestFrom(
        this.store$.select(fromRoot.getSelectedLanguage),
        this.store$.select(fromRoot.getSubscription),
        this.store$.select(fromRoot.getSubscriptionUpdating),
        this.store$.select(fromRoot.getSubscriptionLoaded),
      ),
      takeUntil(isSubscriptionValid$),
    ).subscribe(([store, language, subscription, subscriptionUpdating, subscriptionLoaded]) => {
      if (subscriptionLoaded) {
        if (subscription?.plan) {
          switch (subscription.status) {
            case Constant.subscriptionStatus.PaymentRequired:
              this.redirectionService.redirectToSubscriptionUpdate();
              break;
            case Constant.subscriptionStatus.Inactive:
              this.redirectionService.redirectToPricingPage(language);
              break;
            default:
              isSubscriptionValid$.next(true);
              break;
          }
        } else {
          this.redirectionService.redirectToPricingPage(language);
        }
      }
    });
    return isSubscriptionValid$.asObservable();
  }

}
